import { render } from "./BlckSectionReadItem.vue?vue&type=template&id=b88cb598&scoped=true"
import script from "./BlckSectionReadItem.vue?vue&type=script&lang=js"
export * from "./BlckSectionReadItem.vue?vue&type=script&lang=js"

import "./BlckSectionReadItem.vue?vue&type=style&index=0&id=b88cb598&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88cb598"]])

export default __exports__